export default "__VITE_ASSET__CpGA1Tj2__"